import React from "react";

import { LoadingOutlined } from "@ant-design/icons";
import { Viewer, Worker, SpecialZoomLevel } from "@react-pdf-viewer/core";

import NoResults from "./NoResultsGIF";
import StyledScrollbar from "./UIComponents/StyledScrollbar";

import ErrorIcon from "../../assets/images/EmptyState_V2.png";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "./PdfPreview.css";

export default function PdfPreview({
  blob,
  height,
  scaleType, // scaleType can be ActualSize, PageFit, PageWidth
  scaleNumber = 1,
  scrollBarId,
  scrollBarBorderRadius,
  showLoading = false,
  showError = false,
  handleLoadingDone = () => {},
  onError,
}) {
  if (showError || (!showLoading && !blob)) {
    return (
      <div className="PdfPreview__Loading" style={{ height }}>
        <NoResults image={ErrorIcon} message="Failed to load PDF" className="PdfPreview__Error" />
      </div>
    );
  }

  if (showLoading) {
    return (
      <div className="PdfPreview__Loading" style={{ height }}>
        <LoadingOutlined spin className="PdfPreview__LoadingIcon" />
      </div>
    );
  }

  const viewer = (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
      <Viewer
        fileUrl={blob}
        defaultScale={scaleType ? SpecialZoomLevel[scaleType] : scaleNumber}
        onDocumentLoad={handleLoadingDone}
        renderLoader={() => (
          <div className="PdfPreview__Loading" style={{ height }}>
            <LoadingOutlined spin className="PdfPreview__LoadingIcon" />
          </div>
        )}
        renderError={() => {
          if (onError) {
            onError();
            return null;
          }
          handleLoadingDone();
          return (
            <div className="PdfPreview__Loading" style={{ height }}>
              <NoResults image={ErrorIcon} message="Failed to load PDF" className="PdfPreview__Error" />
            </div>
          );
        }}
      />
    </Worker>
  );

  if (height === "auto") {
    return <div className="PdfPreview PdfPreview--natural">{viewer}</div>;
  }

  return (
    <StyledScrollbar
      id={scrollBarId}
      className="pdf-preview-scroll-bar"
      style={{
        height,
        borderRadius: scrollBarBorderRadius || "8px",
      }}
    >
      {viewer}
    </StyledScrollbar>
  );
}
